module.exports = __webpack_public_path__ + "assets/img/smartTV-module4-2.e68fc4f3.jpg";